<template>
	<div class="file-manager-sub-bar">
		<SubBarGlobal :currentCrumb="$route.meta.crumbName || ''">
			<div class="dF aC" style="gap: 20px;">
				<transition name="bounce">
					<div v-if="copyFileProgress == 100">
						All files copied
					</div>
				</transition>

				<a-dropdown placement="bottomRight" v-if="copyFileList.length > 0"
					:overlayStyle="{ 'max-height': '400px', overflow: 'auto' }">
					<a class="ant-dropdown-link" @click="e => e.preventDefault()">
						<a-progress :width="40" :height="40" type="circle" :percent="copyFileProgress" :strokeWidth="8"
							stroke-color="#87d068" />
					</a>
					<a-menu slot="overlay">
						<a-menu-item class="dF jE">
							<a-button type="danger" ghost @click="$store.commit('COPY_FILE_PROGRESS_RESET_ALL')">
								<a-icon type="delete" />
								Clear All
							</a-button>
						</a-menu-item>
						<a-menu-item v-for="file in copyFileList" :key="file.id + file.operationId">
							<div class="dF aC jSB" style="width: 100%;">
								<div>
									<div class="fileName">
										<a-tooltip :title="file.name" overlayClassName="change-tooltip-color">
											<strong>{{ file.name }}</strong>
										</a-tooltip>
									</div>
									<small class="text-sm">Status:
										<strong style="text-transform: capitalize;">{{ file.status }}</strong>
									</small>
								</div>
								<div class="dF aC ml-3 text-md" style="gap: 20px;">
									<a-icon v-if="['pending', 'in_progress'].includes(file.status)" type="loading"
										style="color: blue;" />
									<a-icon v-else-if="file.status == 'completed'" type="check-circle"
										style="color: var(--primary);" />
									<a-icon v-else-if="file.status == 'failed'" type="delete"
										@click.stop="removeFileProgress(file.operationId, file.id)"
										style="color: #cf2d38;" />
								</div>
							</div>
						</a-menu-item>
					</a-menu>
				</a-dropdown>

				<div v-if="copyFileList.length > 0" class="d-none d-xl-block dash-divider"></div>

				<a-auto-complete style="width: 300px" placeholder="Search for a file..."
					:dropdown-match-select-width="false" :dropdown-style="{ width: '300px' }" option-label-prop="value"
					@search="handleSearch" size="large">
					<template slot="dataSource">
						<a-select-option @click="optionClicked(file.id, file.folder)"
							v-for="(file, fileI) in searchResult" :key="fileI" :value="file.name">
							<div class="dF aC">
								<span v-if="file.Type == 'Image'" class="mr-2"><img
										style="width:30px; height:30px; object-fit:cover;"
										:src="`${file.url}`" /></span>
								<div class="f1">
									<div><strong>{{ file.name }}</strong></div>
									<small class="text-sm">Folder: {{ file.folder === '/' ? 'Main' : file.folder
									}}</small>
								</div>
							</div>
						</a-select-option>
					</template>
					<a-input>
						<a-icon style="stroke:#000; stroke-width:34" slot="prefix" type="search" />
					</a-input>
				</a-auto-complete>

				<div class="d-none d-xl-block dash-divider"></div>
				<PageButtons />
			</div>
		</SubBarGlobal>
	</div>
</template>
<script>
import SubBarGlobal from 'bh-mod/components/layout/SubBarGlobal'
import PageButtons from 'bh-mod/components/layout/SubBarGlobal/PageButtons'

export default {
	components: { SubBarGlobal, PageButtons },
	data() {
		return {
			searchResult: [],
		}
	},
	computed: {
		files() {
			let storeFiles = this.$store.state.files;
			let fileList = []

			for (const folder in storeFiles) {
				if (Object.hasOwnProperty.call(storeFiles, folder)) {
					const files = storeFiles[folder];
					files.forEach((file, index) => {
						if (file.items) {
							if ((fileList.findIndex(x => x.name === file.name && x.id !== index) == -1)) {
								fileList.push({
									name: file.name,
									folder: folder,
									id: index
								})
							}
						} else if (fileList.findIndex(x => x.name === file.name && x.id !== file.id) == -1) {
							const folderName = file.folder.startsWith('/') ? file.folder.replace('/', '') : (file.folder || '/')

							fileList.push({
								name: file.name,
								folder: folderName,
								id: file.id
							})
						}
					})

				}
			}

			return fileList
		},
		pageButtons() {
			return this.$store.state.pageButtons
		},

		copyFileList() {
			return Object.entries(this.$store.state.copyFileProgress).flatMap(([reqId, files]) =>
				files.map(file => ({
					id: file.id,
					name: file.name,
					status: file.status,
					operationId: reqId
				}))
			);
		},

		copyFileProgress() {
			const fileList = this.copyFileList;
			const totalCompleted = fileList.filter(x => x.status == 'completed').length;
			const totalFiles = fileList.length;
			return Math.round((totalCompleted / totalFiles) * 100);
		},
	},
	watch: {
		copyFileProgress(value) {
			if (value == 100) {
				this.$store.dispatch('GET_FILE_STRUCTURE');
				setTimeout(() => {
					this.$store.commit('COPY_FILE_PROGRESS_RESET', { operationId: null, id: null })
				}, 5000)
			}
		}
	},
	methods: {
		async optionClicked(id, folder) {
			await this.$store.commit('changeFolder', folder)
			await document.querySelectorAll('.select').forEach(x => x.classList.remove('select'))
			if (document.querySelector(`[data-row-key="${id}"]`)) {
				document.querySelector(`[data-row-key="${id}"]`).classList.add('select')
			}
		},
		handleSearch(input) {
			if (input && input.length > 2) {
				this.searchResult = Object.values(this.files).filter(({ name }) => {
					name = name.toLowerCase()
					input = input.toLowerCase()
					return name.includes(input)
				})
			} else {
				return this.searchResult = []
			}
		},

		removeFileProgress(operationId = null, id = null) {
			this.$store.commit('COPY_FILE_PROGRESS_RESET', { operationId, id })
		}
	},
}
</script>

<style>
.file-manager-sub-bar .ant-progress-circle.ant-progress-status-success .ant-progress-text {
	color: var(--primary) !important;
}
</style>

<style scoped>
.fileName {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 200px;
}
</style>
